import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';


export const firebaseConfig = { 
  apiKey: "AIzaSyDArzbZ8gvcfBWhraTOtiEPrmdEAaTz5HY",
  authDomain: "multichannel-inquiry-system.firebaseapp.com",
  projectId: "multichannel-inquiry-system",
  storageBucket: "multichannel-inquiry-system.firebasestorage.app",
  messagingSenderId: "240171385312",
  appId: "1:240171385312:web:16ba555d363cf85bc62b85",
  measurementId: "G-DF58M5DFXW"
};

let app;
// Ensure Firebase is only initialized once
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp(); 
}

const db = getFirestore(app);
const auth = getAuth(app); 

// Export the instances and config
export { db, auth, app }; 